import React from 'react'
import PropTypes from 'prop-types'
import {Http, unwrapDynamic, capitalizeFirst} from 'common'


const RESEND_TIMEOUT = 30

export class Resend extends React.Component {
    static contextTypes = {
        messenger: PropTypes.object
    }

    state = {
        disabled: false
    }

    handleSend = () => {
        const data = {
            login: {
                login: this.props.login,
                loginType: this.props.type
            }
        }

        Http.POST(this.props.url, data, this.handleResponse)
    }

    handleResponse = (data, resp, status) => {
        const {messenger} = this.context

        const messageCode = (status == null) ? 'Success' : resp.type
        const messageType = capitalizeFirst(this.props.login)

        messenger.publish(messageCode, 'Resend', messageType)
    }

    handleClick = async () => {
        this.handleSend()
        await this.setState({disabled: true})

        setTimeout(() => {
            this.setState({disabled: false})
        }, RESEND_TIMEOUT)
    }

    render() {
        const disabled = this.state.disabled || this.props.disabled

        if (disabled) {
            return null
        }

        return (
            <div className='auth__repeat-link'>
                Не надійшов код? <a className="auth__link auth__link-margin" onClick={this.handleClick}>
                    Повторити запит
                </a>
            </div>
        )
    }
}
